import React from 'react';
import Icons from 'components/icons';
import styles from './file.module.scss';

const File = ({
  label = '',
  value,
  removeFile,
  ...rest
}) => {
  const isArray = value && value.length;
  return (
    <label className={styles.file}>
      <Icons name="attach" className={styles.icon} />
      <div className={styles.label}>
        {value && isArray && (
          <ul className={styles.list}>
            {value.map(el => (
              <li key={el.name}>
                <span>{el.name}</span>
              </li>
            ))}
          </ul>
        )}
        {value && !isArray && (
        <span>{value.name}</span>
        )}
        {!value && (label)}
      </div>
      <input {...rest} className="input" type="file" />
    </label>
  );
};

export default File;
